





export const getString = (name: string): string => {
  return import.meta.env[name];
}


/**
 * Get boolean (like 1 or true) from .env. Must start with VITE_
 * @param name
 * @param defaultVar
 */
export const getBoolean = (name: string, defaultVar: boolean = true): boolean => {
  const env = import.meta.env[name];
  if (!env){
    return defaultVar
  }
  return env.toLowerCase() === 'true' || env === "1";
}

export const environment = {
  getString,
  getBoolean,
}
export default environment
